import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DiaryActionChip } from '@/components/DiaryHeader/DiaryActionChip';
import { LessonTimesChip } from '@/components/DiaryHeader/LessonTimesChip';
import { WeekPicker } from '@/components/DiaryHeader/WeekPicker';
import { DiaryPrintModal } from '@/components/DiaryPrintModal';
import { DownloadFilled } from '@/components/Icons/DownloadFilled';
import type { DiaryEntry } from '@/types/diary';
import { tv } from '@/utils/tv';

const header = tv({
  base: 'flex items-end justify-between gap-4 px-6 pt-6',
  variants: {
    isBottom: { true: 'pb-8', false: 'pb-5' },
  },
});

interface Props {
  entries: DiaryEntry[];
  selectedDate: Date;
  minDate?: Date;
  maxDate?: Date;
  isBottom?: boolean;
  onDateChange: (date: Date) => void;
  onCalendarSelect: (date: Date) => void;
}

export const DiaryHeader: React.FC<Props> = ({
  entries,
  selectedDate,
  minDate,
  maxDate,
  isBottom = false,
  onDateChange,
  onCalendarSelect,
}) => {
  const { t } = useTranslation();
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);

  return (
    <div className={header({ isBottom })}>
      <WeekPicker
        value={selectedDate}
        minDate={minDate}
        maxDate={maxDate}
        hasCalendarAbove={isBottom}
        onChange={onDateChange}
        onCalendarSelect={onCalendarSelect}
      />
      <div className="flex items-center gap-2">
        <DiaryActionChip
          label={t('diary.downloadPdf')}
          icon={<DownloadFilled className="size-4" />}
          onClick={() => setIsPrintModalOpen(true)}
        />
        <LessonTimesChip />
      </div>

      {isPrintModalOpen && (
        <DiaryPrintModal
          entries={entries}
          onClose={() => setIsPrintModalOpen(false)}
        />
      )}
    </div>
  );
};
